webpackJsonp([83660894728409],{

/***/ 362:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>I gave one of the Keswick Hall books to one of my friends who grew up in Keswick and I just received the sweetest THANK YOU note - she said she couldn't put it down and knows alot of the people mentioned in your book - kudos!!! I find it an interesting and exciting read and I don't know a soul :)</p>\n<p>Thank you for sharing your \"labor of love\" with all of us!!!!</p>","frontmatter":{"path":"/content/labor-love","year":"1990-1999","title":"Labor of Love","image":null,"imagetitle":null,"author":"Barb Beadle","publication":null}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---content-labor-love-83423ddeee0480b6880a.js